import { Fetch, schemas, CreateNotebookBodyType } from '@convergence/client';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { fetch } from '../fetch';

export async function createNotebook(
  data: CreateNotebookBodyType,
  fetch: Fetch
) {
  return fetch(
    `/notebook`,
    { method: 'post', body: JSON.stringify(data) },
    schemas.CreateNotebookDto
  );
}

export const useCreateNotebookMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['createNotebook'],
    mutationFn: async (data: CreateNotebookBodyType) => {
      const result = createNotebook(data, fetch);
      return result;
    },

    onSuccess: async () => {
      console.log('created notebook');
      await queryClient.invalidateQueries({ queryKey: ['notebooks'] });
    }
  });
};
